import React from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import classnames from "classnames";

import "./Toggle.styles.scss";

export interface ToggleProps {
  onChange: (value: boolean) => void;
  value: boolean;
  labelPosition?: "top" | "bottom" | "left" | "right";
  label?: string;
  toggleClassName?: string;
  labelClassName?: string;
  size?: number;
  disabled?: boolean;
}

export const ToggleWithLabel: React.FC<ToggleProps> = ({
  onChange,
  value,
  label,
  labelPosition = "top",
  toggleClassName = "",
  labelClassName = "",
  ...props
}) => {
  return (
    <label className={classnames("toggle", `toggle--${labelPosition}`)}>
      <span className={classnames("toggle__label", labelClassName)}>
        {label}
      </span>
      <Toggle
        icons={false}
        checked={value}
        className={classnames("toggle-custom", toggleClassName)}
        onChange={(e) => onChange(e.target.checked)}
        {...props}
      />
    </label>
  );
};
